import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    summaryCompanyCardAvatarImage: {
        height: "100%",
        width: "100%"
    },
    summaryCompanyCardContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    avatarContainer: {
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden"
    },
    companyCardAvatar: {
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        height: 64,
        width: 64
    },
    summaryCompanyCardAvatar: {
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        height: 48,
        width: 48
    },
    summaryCompanyCardInfo: {
        justifyContent: "center",
        flexDirection: "column"
    },
    container: {
        flexDirection: "column",
        width: "100%"
    },
    profileCard: {
        flexDirection: "column",
        width: "100%"
    },
    infoContainer: {
        flexDirection: "column",
        flex: 1
    },
    detailSection: {
        flexDirection: "column",
        width: "100%"
    },
    detailCol: {
        flexDirection: "column",
        flex: 1
    },
    profileHeader: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    detailRow: {
        flexDirection: "row",
        width: "100%"
    },
    companyCardContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    companyCardAvatarImage: {
        height: "100%",
        width: "100%"
    },
    companiesListContainer: {
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    avatarImage: {
        height: "100%",
        width: "100%"
    },
    companyCardInfo: {
        flex: 1
    }
});

export default stylesheet;
